<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <h1 v-translate>Crony</h1>
      </div>

      <app-table
          :data="items"
          :highlight-rows-on-hover="true"
          clickable
          :order="params.order"
          :page-size="params.limit"
          @sort="sortItems"
          @rowClick="goToDetail"
          :loading="listLoading"
      >
        <app-table-column first attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              {{ row.name }}
            </strong>
          </template>
        </app-table-column>
        <app-table-column attribute="totalRuns" :label="translations.totalRuns" />
        <app-table-column attribute="totalRunsLast24h" :label="translations.totalRunsLast24h" />
        <app-table-column attribute="lastCronRunStatus" :label="translations.lastStatus">
          <template slot-scope="row">
            {{ enumsMap.get(row.lastCronRunStatus) }}
          </template>
        </app-table-column>
        <app-table-column attribute="lastCronRunResult" :label="translations.lastResult">
          <template slot-scope="row">
            <img
                v-if="row.lastCronRunResult === 'ok'"
                class="is_set"
                title="OK"
                alt="OK"
                src="../../assets/images/is-set.svg"
            >
            <img
                v-if="row.lastCronRunResult === 'warning'"
                class="is_set"
                :title="translations.warning"
                :alt="translations.warning"
                src="../../assets/images/warning.svg"
            >
            <img
                v-if="row.lastCronRunResult === 'error'"
                class="is_set"
                :title="translations.error"
                :alt="translations.error"
                src="../../assets/images/isnot-set.svg"
            >
          </template>
        </app-table-column>
        <app-table-column attribute="enabled" :label="translations.enabled">
          <template slot-scope="row">
            <app-graphic-image
              :value="row.enabled"
            />
          </template>
        </app-table-column>
        <app-table-column>
          <template slot-scope="row">
            <app-button
                v-if="row.lastCronRunStatus === 'running' ? false : true"
                @click.stop="clickRun(row._id)"
                v-translate
            >
                Spustit
            </app-button>
            <app-button
                v-if="row.lastCronRunStatus === 'running' ? true : false"
                class="btn_orange"
                @click.stop="clickUnlock(row._id)"
                v-translate
            >
                Odemknout
            </app-button>
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
            :page="listPage"
            :itemsPerPage="params.limit"
            :totalCount="itemsMetadata.totalCount"
            @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { mapActions } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Crons',
  enumsMap: true
})

export default {
  name: 'station-groups',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  data() {
    return {
      code: null
    }
  },
  computed: {
    translations() {
      return {
        name: this.$gettext('Název'),
        totalRuns: this.$gettext('Celkový počet běhů'),
        totalRunsLast24h: this.$gettext('Počet běhů za posledních 24h'),
        lastStatus: this.$gettext('Poslední status'),
        lastResult: this.$gettext('Poslední výsledek'),
        warning: this.$gettext('Varování'),
        error: this.$gettext('Chyba'),
        enabled: this.$gettext('Povoleno'),
        icon: this.$gettext('Ikona')
      }
    },
    currentTitle() {
      return [
        this.$gettext('Crony')
      ]
    }
  },
  methods: {
    ...mapActions([
      'getCronCode',
      'getCrons',
      'runCron',
      'unlockCron'
    ]),
    async fetchItems() {
      this.getCrons()
    },
    async clickRun(id) {
      const result = await this.getCronCode()
      const run = this.runCron({ params: { code: result.data.code, id } })
      run.then(
        this.fetchItems()
      )
    },
    async clickUnlock(id) {
      const unlock = await this.unlockCron({ params: { id } })
      unlock.then(
        this.fetchItems()
      )
    }
  }
}
</script>
